/* eslint-disable camelcase */
import { useMutation } from '@tanstack/react-query'
import { Auth } from 'aws-amplify'
import { ReactQueryKeys } from '@/types'
import { validateEmail, validatePhoneNumber } from '@/utils/helper'

export const useSignup = (user: string, password: string) => {
  return useMutation({
    mutationKey: [ReactQueryKeys.SIGNUP, user, password],
    mutationFn: async (): Promise<boolean> => {
      await Auth.signUp({
        username: user,
        password: password,
        attributes: {
          email: validateEmail(user) ? user : '',
          // Cognito's schema marks these Required and rejects empty strings.
          // Real values aren't collected until the next step of the wizard,
          // so we send placeholders here and overwrite them with the real
          // name in useRegisterCognito once it's known.
          given_name: 'Pending',
          family_name: 'Signup',
          phone_number: validatePhoneNumber(user) ? user : '',
        },
      })
      return true
    },
  })
}
